module.exports = __webpack_public_path__ + "zillowIcon.59a3212.png";